export default __webpack_public_path__ + "static/media/document-economy-icon.2997d8e1.svg";